// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__5Nih7 {
  display: flex;
  flex-direction: column;
  padding: 50px;

  @media (max-width: 519px) {
    padding: 20px;
  }

  @media (min-width: 520px) and (max-width: 1020px) {
    padding: 30px;
  }
}

.style_header__qJzdl {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
}

.style_headerCalendar__Y1CzF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: 519px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
}

.style_options__5atLT {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 30px;
  margin-bottom: 35px;

  @media (max-width: 519px) {
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    flex-wrap: nowrap;
  }

  @media (min-width: 1021px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;
  }
}

.style_selectWrapper__F7mYL {
  width: 100%;
}

@media (min-width: 1021px) {
  .style_selectWrapper__F7mYL {
    width: auto;
    width: 250px;
    /* min-width: 250px; */
  }
}

.style_text_field__5njzh {
  width: 300px;

  @media (max-width: 519px) {
    width: 100%;
  }

  @media (min-width: 520px) and (max-width: 1020px) {
    width: 100%;
  }

  @media (min-width: 1021px) {
    width: 300px;
  }
}

.style_day__hJF4N {
  display: flex;
  font-size: 16px;
  background-color: var(--table-header-bg);
  border: none;
  width: 100%;
  cursor: pointer;
}
.style_fc__\\+7llt .style_fc-timegrid-axis-cushion__XsCL\\+ {
  flex-shrink: 0;
  max-width: 151px;
  margin: 100px 0;
}

/* Calendar table header styles - using :global() for CSS modules */
.fc .fc-col-header-cell {
  padding: 10px !important;
  background-color: var(--table-row-alt) !important;
}

.fc .fc-col-header th {
  padding: 10px !important;
  background-color: var(--table-row-alt) !important;
}

.fc-theme-standard .fc-col-header-cell {
  padding: 10px !important;
  background-color: var(--table-row-alt) !important;
}

/* Calendar table body styles - using :global() for CSS modules */
.fc .fc-scrollgrid-section-body table tbody {
  background-color: var(--table-row-white) !important;
}

.fc .fc-daygrid-body {
  background-color: var(--table-row-white) !important;
}

.fc .fc-scrollgrid-sync-table {
  background-color: var(--table-row-white) !important;
}

.fc-theme-standard .fc-scrollgrid {
  background-color: var(--table-row-white) !important;
}

.fc .fc-daygrid-day {
  background-color: var(--table-row-white) !important;
}

.fc .fc-daygrid-day-frame {
  background-color: var(--table-row-white) !important;
}

/* Enhanced Calendar event improvements */
.fc-event {
  border-radius: 8px !important;
  border: 1px solid var(--table-border) !important;
  box-shadow: none !important;
  margin: 2px !important;
  transition: all 0.2s ease !important;
  background: var(--table-row-white) !important;
  overflow: hidden !important;
  position: relative !important;
}

.fc-event:before {
  content: '' !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 3px !important;
  height: 100% !important;
  background: #2563eb !important;
  border-radius: 0 !important;
}

.fc-event:hover {
  background: var(--table-hover) !important;
  border-color: var(--border-hover) !important;
  transform: none !important;
  box-shadow: none !important;
}

.fc-event:hover:before {
  width: 3px !important;
}

.fc-event .fc-event-main {
  padding: 0 !important;
  position: relative !important;
  z-index: 1 !important;
  text-align: left !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  display: flex !important;
  width: 100% !important;
  height: 100% !important;
}

.fc-event .fc-event-title {
  padding: 0 !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  color: transparent !important;
}

/* Enhanced calendar day cells spacing for new event design */
.fc-daygrid-day-events {
  padding: 6px !important;
  min-height: 100px !important;
}

.fc-daygrid-event {
  margin: 2px 0 !important;
  min-height: 60px !important;
  overflow: hidden !important;
}

.fc-daygrid-day {
  min-height: 120px !important;
}

/* Fix text alignment and overflow in calendar events */
.fc-event .fc-event-main .fc-event-main-frame {
  text-align: left !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

/* Ensure the content inside events is properly aligned */
.fc-event .fc-event-main .fc-event-main-frame > div {
  text-align: left !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;
}

/* Better calendar grid appearance */
.fc .fc-daygrid-day-top {
  padding: 8px !important;
}

.fc .fc-daygrid-day-number {
  padding: 4px 8px !important;
  font-weight: 600 !important;
  color: var(--text-heading) !important;
}

/* Loading overlay styles */
.style_loadingOverlay__LwTCo {
  display: flex;
  position: fixed;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  z-index: 5;
  width: 100%;
  height: 100vh;
  backdrop-filter: blur(5px);
  left: 0;
  top: 0;
}

.style_loadingContent__bO\\+Hj {
  text-align: center;
}

/* Filters container */
.style_filtersContainer__CNJ0q {
  margin-bottom: 16px;
}

.style_filtersBox__QYZHs {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  align-items: center;
  flex-wrap: wrap;
}

/* Form controls */
.style_formControl__fT1h9 {
  max-width: 450px;
  width: 100%;
}

/* Reset button */
.style_resetButton__FAyKP {
  min-width: 120px;
  height: 56px;
  color: #1976d2;
  border-color: #1976d2;
}

.style_resetButton__FAyKP:hover {
  background-color: #f5f5f5;
  border-color: #1976d2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Calendar/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;;EAEb;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;;EAEnB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,SAAS;EACT,mBAAmB;;EAEnB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,YAAY;;EAEZ;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA,iEAAiE;AACjE;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA,yCAAyC;AACzC;EACE,6BAA6B;EAC7B,gDAAgD;EAChD,2BAA2B;EAC3B,sBAAsB;EACtB,oCAAoC;EACpC,6CAA6C;EAC7C,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,6DAA6D;AAC7D;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  padding: 50px;\n\n  @media (max-width: 519px) {\n    padding: 20px;\n  }\n\n  @media (min-width: 520px) and (max-width: 1020px) {\n    padding: 30px;\n  }\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.headerCalendar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n\n  @media (max-width: 519px) {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n}\n\n.options {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  gap: 30px;\n  margin-bottom: 35px;\n\n  @media (max-width: 519px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 20px;\n    flex-wrap: nowrap;\n  }\n\n  @media (min-width: 1021px) {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 30px;\n    flex-wrap: wrap;\n  }\n}\n\n.selectWrapper {\n  width: 100%;\n}\n\n@media (min-width: 1021px) {\n  .selectWrapper {\n    width: auto;\n    width: 250px;\n    /* min-width: 250px; */\n  }\n}\n\n.text_field {\n  width: 300px;\n\n  @media (max-width: 519px) {\n    width: 100%;\n  }\n\n  @media (min-width: 520px) and (max-width: 1020px) {\n    width: 100%;\n  }\n\n  @media (min-width: 1021px) {\n    width: 300px;\n  }\n}\n\n.day {\n  display: flex;\n  font-size: 16px;\n  background-color: var(--table-header-bg);\n  border: none;\n  width: 100%;\n  cursor: pointer;\n}\n.fc .fc-timegrid-axis-cushion {\n  flex-shrink: 0;\n  max-width: 151px;\n  margin: 100px 0;\n}\n\n/* Calendar table header styles - using :global() for CSS modules */\n:global(.fc .fc-col-header-cell) {\n  padding: 10px !important;\n  background-color: var(--table-row-alt) !important;\n}\n\n:global(.fc .fc-col-header th) {\n  padding: 10px !important;\n  background-color: var(--table-row-alt) !important;\n}\n\n:global(.fc-theme-standard .fc-col-header-cell) {\n  padding: 10px !important;\n  background-color: var(--table-row-alt) !important;\n}\n\n/* Calendar table body styles - using :global() for CSS modules */\n:global(.fc .fc-scrollgrid-section-body table tbody) {\n  background-color: var(--table-row-white) !important;\n}\n\n:global(.fc .fc-daygrid-body) {\n  background-color: var(--table-row-white) !important;\n}\n\n:global(.fc .fc-scrollgrid-sync-table) {\n  background-color: var(--table-row-white) !important;\n}\n\n:global(.fc-theme-standard .fc-scrollgrid) {\n  background-color: var(--table-row-white) !important;\n}\n\n:global(.fc .fc-daygrid-day) {\n  background-color: var(--table-row-white) !important;\n}\n\n:global(.fc .fc-daygrid-day-frame) {\n  background-color: var(--table-row-white) !important;\n}\n\n/* Enhanced Calendar event improvements */\n:global(.fc-event) {\n  border-radius: 8px !important;\n  border: 1px solid var(--table-border) !important;\n  box-shadow: none !important;\n  margin: 2px !important;\n  transition: all 0.2s ease !important;\n  background: var(--table-row-white) !important;\n  overflow: hidden !important;\n  position: relative !important;\n}\n\n:global(.fc-event:before) {\n  content: '' !important;\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 3px !important;\n  height: 100% !important;\n  background: #2563eb !important;\n  border-radius: 0 !important;\n}\n\n:global(.fc-event:hover) {\n  background: var(--table-hover) !important;\n  border-color: var(--border-hover) !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n:global(.fc-event:hover:before) {\n  width: 3px !important;\n}\n\n:global(.fc-event .fc-event-main) {\n  padding: 0 !important;\n  position: relative !important;\n  z-index: 1 !important;\n  text-align: left !important;\n  justify-content: flex-start !important;\n  align-items: flex-start !important;\n  display: flex !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n:global(.fc-event .fc-event-title) {\n  padding: 0 !important;\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  color: transparent !important;\n}\n\n/* Enhanced calendar day cells spacing for new event design */\n:global(.fc-daygrid-day-events) {\n  padding: 6px !important;\n  min-height: 100px !important;\n}\n\n:global(.fc-daygrid-event) {\n  margin: 2px 0 !important;\n  min-height: 60px !important;\n  overflow: hidden !important;\n}\n\n:global(.fc-daygrid-day) {\n  min-height: 120px !important;\n}\n\n/* Fix text alignment and overflow in calendar events */\n:global(.fc-event .fc-event-main .fc-event-main-frame) {\n  text-align: left !important;\n  justify-content: flex-start !important;\n  align-items: flex-start !important;\n  width: 100% !important;\n  height: 100% !important;\n  overflow: hidden !important;\n}\n\n/* Ensure the content inside events is properly aligned */\n:global(.fc-event .fc-event-main .fc-event-main-frame > div) {\n  text-align: left !important;\n  width: 100% !important;\n  height: 100% !important;\n  overflow: hidden !important;\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: flex-start !important;\n  align-items: flex-start !important;\n}\n\n/* Better calendar grid appearance */\n:global(.fc .fc-daygrid-day-top) {\n  padding: 8px !important;\n}\n\n:global(.fc .fc-daygrid-day-number) {\n  padding: 4px 8px !important;\n  font-weight: 600 !important;\n  color: var(--text-heading) !important;\n}\n\n/* Loading overlay styles */\n.loadingOverlay {\n  display: flex;\n  position: fixed;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  z-index: 5;\n  width: 100%;\n  height: 100vh;\n  backdrop-filter: blur(5px);\n  left: 0;\n  top: 0;\n}\n\n.loadingContent {\n  text-align: center;\n}\n\n/* Filters container */\n.filtersContainer {\n  margin-bottom: 16px;\n}\n\n.filtersBox {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* Form controls */\n.formControl {\n  max-width: 450px;\n  width: 100%;\n}\n\n/* Reset button */\n.resetButton {\n  min-width: 120px;\n  height: 56px;\n  color: #1976d2;\n  border-color: #1976d2;\n}\n\n.resetButton:hover {\n  background-color: #f5f5f5;\n  border-color: #1976d2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__5Nih7`,
	"header": `style_header__qJzdl`,
	"headerCalendar": `style_headerCalendar__Y1CzF`,
	"options": `style_options__5atLT`,
	"selectWrapper": `style_selectWrapper__F7mYL`,
	"text_field": `style_text_field__5njzh`,
	"day": `style_day__hJF4N`,
	"fc": `style_fc__+7llt`,
	"fc-timegrid-axis-cushion": `style_fc-timegrid-axis-cushion__XsCL+`,
	"loadingOverlay": `style_loadingOverlay__LwTCo`,
	"loadingContent": `style_loadingContent__bO+Hj`,
	"filtersContainer": `style_filtersContainer__CNJ0q`,
	"filtersBox": `style_filtersBox__QYZHs`,
	"formControl": `style_formControl__fT1h9`,
	"resetButton": `style_resetButton__FAyKP`
};
export default ___CSS_LOADER_EXPORT___;
